import { _LogoHasBackgroundBase } from './logoHasBackgroundBase'
export class _LogoHasBackgroundDefault extends _LogoHasBackgroundBase {
  cssType: 'default' = 'default'
  protected initPC(): this {
    this['--logo-has-background-width'] = '0.5rem'
    this['--logo-has-background-height'] = '0.5rem'
    this['--logo-icon-width'] = '0.5rem'
    this['--logo-icon-height'] = '0.5rem'
    this['--logo-has-background-color'] = '#fff'
    return this
  }
  protected initH5(): this {
    this['--logo-has-background-width'] = '0.5rem'
    this['--logo-has-background-height'] = '0.5rem'
    this['--logo-icon-width'] = '0.5rem'
    this['--logo-icon-height'] = '0.5rem'
    this['--logo-has-background-color'] = 'transparent'
    return this
  }
}
